import { hexUint8Array } from '../io/utils';
import { compare } from '../utils';
const PACKET_BYTES = new Uint8Array([34, 112, 97, 99, 107, 101, 116, 34]);
const LEFT_CURLY_BRACKET_CHAR_INT = 123;
export function serializePacket(packet) {
    const raw = [
        'packet',
        packet.id,
        { range: packet.frameRange, firstFrameTime: packet.firstFrameTime, lastFrameTime: packet.lastFrameTime },
    ];
    const serialized = new TextEncoder().encode(JSON.stringify(raw));
    const buffer = new Uint8Array(serialized.length + packet.data.length + 1);
    buffer.set(serialized, 0);
    buffer.set(new Uint8Array([0]), serialized.length);
    buffer.set(packet.data, serialized.length + 1);
    return buffer;
}
export function isPacketBytes(bytes) {
    return compare(PACKET_BYTES, bytes.slice(1, 9));
}
export function getPacketID(bytes) {
    const idx = bytes.findIndex((v) => v === LEFT_CURLY_BRACKET_CHAR_INT);
    const id = bytes.slice(11, idx - 2);
    return new TextDecoder().decode(id);
}
